module.exports = __webpack_public_path__ + "static/media/tuto-1.cecf7abd.jpg";